// src/pages/Attendance/LeaveStatusList.tsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { RootDispatch, RootState } from "../../store";
import { fetchAllLeaveApplications } from "../../store/slices/leaveSlice";
import { fetchAllRegularizeRequests } from "../../store/slices/regularizeSlice";
import LeaveCard from "./LeaveCard";
import RegularizationCard from "./RegularizationCard";

export type StatusListType = "pending" | "history";
export type StatusListContext = "leave" | "regularization";

interface LeaveStatusListProps {
  type: StatusListType;
  context: StatusListContext;
}

const LeaveStatusList: React.FC<LeaveStatusListProps> = ({ type, context }) => {
  const dispatch = useDispatch<RootDispatch>();

  useEffect(() => {
    if (context === "leave") {
      dispatch(fetchAllLeaveApplications());
    } else if (context === "regularization") {
      dispatch(fetchAllRegularizeRequests());
    }
  }, [dispatch, context]);

  const pendingLeaves = useSelector(
    (state: RootState) => state.leave.pendingApplications
  );
  const historyLeaves = useSelector(
    (state: RootState) => state.leave.leaveHistory
  );

  const pendingRegularizations = useSelector(
    (state: RootState) => state.regularize.pendingRegularizationApplications
  );
  const regularizationHistory = useSelector(
    (state: RootState) => state.regularize.regularizationHistory
  );
  let applications: any[] = [];
  let CardComponent: React.ComponentType<any> = LeaveCard;

  if (context === "leave") {
    applications = type === "pending" ? pendingLeaves : historyLeaves;
    CardComponent = LeaveCard;
  } else {
    applications =
      type === "pending" ? pendingRegularizations : regularizationHistory;
    CardComponent = RegularizationCard;
  }

  return (
    <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-3">
      <h2 className="text-base font-bold text-gray-800 mb-6 pb-2 border-b border-gray-100">
        {type === "pending" ? "Pending Requests" : "History"}
      </h2>

      {applications.length === 0 ? (
        <div className="text-center py-10">
          <p className="text-gray-500 text-lg">
            No {type} {context} applications found.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {applications.map((application) => (
            <CardComponent
              key={application._id}
              application={application}
              type={type}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default LeaveStatusList;
